import { Button, ButtonProps } from '@mui/material';
import React from 'react';

export default function RoundedPrimaryButton({ ...props }: ButtonProps) {
  return (
    <Button
      {...props}
      variant="contained"
      sx={{
        borderRadius: 4,
        fontSize: 16,
        backgroundColor: '#7C28E3',
        ...props.sx,
      }}
    ></Button>
  );
}
